import { assign, defaultsDeep } from 'lodash-es';

import { Config } from './config';

export function buildDefaultConfig(config: Config, environment: any): Config {
  const isSit = config.environment.baseUrl?.indexOf('-sit.mworker.com') !== -1;

  if (isSit) {
    environment.reportsServiceEndpoint =
      environment.reportsServiceEndpoint.replace(
        '.mworker.com',
        '-sit.mworker.com'
      );

    // environment.componentsLibraryEndpoint =
    //   environment.componentsLibraryEndpoint.replace(
    //     '.mworker.com',
    //     '-sit.mworker.com'
    //   );

    environment.tokenEndpoint = environment.tokenEndpoint.replace(
      '.mworker.com',
      '-sit.mworker.com'
    );

    // environment.attachmentsService.uri =
    //   environment.attachmentsService.uri.replace(
    //     '.mworker.com',
    //     '-sit.mworker.com'
    //   );
  }

  const _default = defaultsDeep({}, config.environment, environment);
  config.environment = _default;
  assign(environment, _default);

  return config;
}
